import { render, staticRenderFns } from "./ErpTemplate.vue?vue&type=template&id=e27f7488&scoped=true&"
import script from "./ErpTemplate.vue?vue&type=script&lang=js&"
export * from "./ErpTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ErpTemplate.vue?vue&type=style&index=0&id=e27f7488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27f7488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e27f7488')) {
      api.createRecord('e27f7488', component.options)
    } else {
      api.reload('e27f7488', component.options)
    }
    module.hot.accept("./ErpTemplate.vue?vue&type=template&id=e27f7488&scoped=true&", function () {
      api.rerender('e27f7488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/layout-demo/ErpTemplate.vue"
export default component.exports